/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_View_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "View/Edit Notes" |
*
* @param {Event_Notes_View_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_view_edit_title = /** @type {((inputs?: Event_Notes_View_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_View_Edit_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir/Modifier les notes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Notizen ansehen/bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza/modifica note")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Просмотреть/редактировать заметки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver/Editar notas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("查看/编辑笔记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メモの表示/編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स देखें/संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ver/Editar notas")
	return /** @type {LocalizedString} */ ("View/Edit Notes")
});